export type HomeLocale = 'zh' | 'en'

export const videoHomeCopy = {
  zh: {
    pageTitle: 'Nova·云枢｜中文 AI 视频创作与培训平台',
    header: {
      homeAria: 'Nova·云枢首页',
      brandSubtitle: '中文 AI 视频创作平台',
      navigationAria: '首页导航',
      openMenu: '打开导航菜单',
      closeMenu: '关闭导航菜单',
      discoverWorks: '发现作品',
      creators: '创作者',
      taskMarket: '接单广场',
      aigcClass: 'AIGC 课堂',
      businessCooperation: '商业合作',
      productsAndServices: '产品与服务',
      aiStudio: 'AI 视频工作台',
      aiStudioStatus: 'Nova AI 创作平台',
      yingliu: '影流',
      yingliuStatus: '视频内容与学习服务',
      miniProgram: 'Nova·云枢小程序',
      miniProgramStatus: '微信扫码进入',
      openPlatform: '开放平台',
      openPlatformStatus: '企业级视频能力接入',
      searchWorks: '搜索作品',
      login: '登录',
      openMiniProgram: '小程序入口',
      switchLanguage: 'EN',
      switchLanguageAria: '切换到英文版',
    },
    page: {
      heroTagline: '中文 AI 视频创作平台',
      startCreating: '开始创作',
      exploreVideos: '浏览作品',
      featuredTitle: '精选视频',
      featuredDescription: '悬停预览，点击进入沉浸式播放器。',
      viewWorks: '查看作品库',
      viewDetails: '查看详情',
      tryNow: '立即体验',
      creationTitle: 'AI 视频创作',
      creationDescription: '输入文字、图片或参考素材后，进入 Nova AI 创作平台生成视频。本官网只负责案例展示和业务分流，不重复开发生成平台。',
      enterPlatform: '进入视频创作平台',
      playGeneratedCase: '播放生成案例',
      generatedCaseAlt: 'AI 视频创作案例封面',
      coursesTitle: '课程试看',
      coursesDescription: '课程仍是二级业务，在首页仅展示少量现有视频片段。',
      enterLearningCenter: '进入学习中心',
      courseDescriptionSupplement: '从课程片段了解创作方法、镜头设计与项目流程。',
      courseFormat: '项目实战',
      freePreview: '免费试看',
      enterCourse: '进入课程',
      verticalTitle: '竖屏作品',
      verticalDescription: '9:16 人物短视频与 1:1 商品内容，桌面悬停预览，手机点击播放。',
      productTitle: '开始生成 AI 视频',
      productDescription: 'Nova AI 创作平台已独立运行，当前网站只设置清晰入口。',
      openGenerator: '打开视频生成工具',
      aiStudio: 'AI 视频工作台',
      aiStudioStatus: 'Nova AI 创作平台',
      yingliu: '影流',
      yingliuStatus: '视频内容与学习服务',
      miniProgram: 'Nova·云枢小程序',
      miniProgramStatus: '微信扫码进入',
      openPlatform: '开放平台',
      openPlatformStatus: '企业级视频能力接入',
      footerTitle: 'Nova·云枢 AI 视频创作平台',
      footerNote: '作品展示、创作工具、课程与企业服务',
    },
    video: {
      play: '播放',
      pause: '暂停视频',
      playVideo: '播放视频',
      mute: '静音',
      unmute: '打开声音',
      fullscreen: '全屏播放',
      loading: '视频加载中',
      fallbackCover: '备用封面',
      loadFailed: '视频加载失败，已显示备用封面',
      closePlayer: '关闭播放器',
    },
  },
  en: {
    pageTitle: 'Nova | AI Video Creation and Training Platform',
    header: {
      homeAria: 'Nova home',
      brandSubtitle: 'AI Video Creation Platform',
      navigationAria: 'Homepage navigation',
      openMenu: 'Open navigation menu',
      closeMenu: 'Close navigation menu',
      discoverWorks: 'Discover',
      creators: 'Creators',
      taskMarket: 'Projects',
      aigcClass: 'AIGC Courses',
      businessCooperation: 'Business',
      productsAndServices: 'Products & Services',
      aiStudio: 'AI Video Studio',
      aiStudioStatus: 'Nova AI creation platform',
      yingliu: 'Yingliu',
      yingliuStatus: 'Video content and learning services',
      miniProgram: 'Nova Mini Program',
      miniProgramStatus: 'Scan with WeChat',
      openPlatform: 'Open Platform',
      openPlatformStatus: 'Enterprise video integration',
      searchWorks: 'Search work',
      login: 'Sign in',
      openMiniProgram: 'Mini Program',
      switchLanguage: '中文',
      switchLanguageAria: 'Switch to Chinese',
    },
    page: {
      heroTagline: 'AI video creation, from idea to final cut',
      startCreating: 'Start creating',
      exploreVideos: 'Explore videos',
      featuredTitle: 'Featured Videos',
      featuredDescription: 'Hover to preview. Open any story in the immersive player.',
      viewWorks: 'View all work',
      viewDetails: 'View story',
      tryNow: 'Try it now',
      creationTitle: 'Create with AI Video',
      creationDescription: 'Bring a prompt, an image or a reference clip into the Nova AI creation platform. This site presents the work and guides each audience to the right product instead of rebuilding the creation engine.',
      enterPlatform: 'Open the video studio',
      playGeneratedCase: 'Play creation demo',
      generatedCaseAlt: 'AI video creation demo cover',
      coursesTitle: 'Course Preview',
      coursesDescription: 'Training remains a focused secondary path, with only a few practical clips on the homepage.',
      enterLearningCenter: 'Open learning center',
      courseDescriptionSupplement: 'See the creative method, shot design and project workflow in context.',
      courseFormat: 'Project-based',
      freePreview: 'Watch preview',
      enterCourse: 'View course',
      verticalTitle: 'Vertical Stories',
      verticalDescription: '9:16 people-led shorts and 1:1 product stories, designed for hover on desktop and tap on mobile.',
      productTitle: 'Start Creating AI Video',
      productDescription: 'The Nova AI creation platform runs independently. This site provides the clearest route into it.',
      openGenerator: 'Open video generator',
      aiStudio: 'AI Video Studio',
      aiStudioStatus: 'Nova AI creation platform',
      yingliu: 'Yingliu',
      yingliuStatus: 'Video content and learning services',
      miniProgram: 'Nova Mini Program',
      miniProgramStatus: 'Scan with WeChat',
      openPlatform: 'Open Platform',
      openPlatformStatus: 'Enterprise video integration',
      footerTitle: 'Nova AI Video Creation Platform',
      footerNote: 'Stories, creation tools, learning and enterprise services',
    },
    video: {
      play: 'Play',
      pause: 'Pause video',
      playVideo: 'Play video',
      mute: 'Mute',
      unmute: 'Turn sound on',
      fullscreen: 'Enter fullscreen',
      loading: 'Loading video',
      fallbackCover: 'fallback cover',
      loadFailed: 'Video failed to load. The fallback cover is still available.',
      closePlayer: 'Close player',
    },
  },
} as const

export const getVideoHomeCopy = (locale: HomeLocale) => videoHomeCopy[locale]
